// Compatibility shim. After the SPA refactor, server functions are just async
// functions. This is a no-op that lets existing call sites keep their
// `useServerFn(fn)` wrapper untouched. Returns the function unchanged.
export function useServerFn<T extends (...args: any[]) => any>(fn: T): T {
  return fn;
}
